import { StatusBar, Style } from "@capacitor/status-bar";

import { IS_CAPACITOR } from "@src/env";

/**
 * Explicitly configure the native status bar so overlay behavior is intentional.
 * CSS `env(safe-area-inset-*)` still owns layout clearance (required on Android 15+).
 */
export async function configureCapacitorStatusBar(): Promise<void> {
  if (!IS_CAPACITOR) {
    return;
  }

  try {
    await StatusBar.setOverlaysWebView({ overlay: true });
    await StatusBar.setStyle({ style: Style.Default });
  } catch {
    // StatusBar may be unavailable in some WebView/simulator configurations.
  }
}
